export default "__VITE_PUBLIC_ASSET__200ca38f__"